import type { TTranslationFunction } from '@/types'

import { QR_TYPE } from '../generatorTypes'

export const QR_TYPE_TO_TRANSLATION_KEY = {
	[QR_TYPE.Url]: 'generator__step_1__qr_type_cards__url__title',
	[QR_TYPE.VCard]: 'generator__step_1__qr_type_cards__vcard__title',
	[QR_TYPE.Pdf]: 'generator__step_1__qr_type_cards__pdf__title',
	[QR_TYPE.Images]: 'generator__step_1__qr_type_cards__images__title',
	[QR_TYPE.SocialMedia]:
		'generator__step_1__qr_type_cards__social_media__title',
	[QR_TYPE.Video]: 'generator__step_1__qr_type_cards__video__title',
	[QR_TYPE.PlainText]: 'generator__step_1__qr_type_cards__plain_text__title',
	[QR_TYPE.BusinessPage]:
		'generator__step_1__qr_type_cards__business_page__title',
	[QR_TYPE.Facebook]: 'generator__step_1__qr_type_cards__facebook__title',
	[QR_TYPE.Wifi]: 'generator__step_1__qr_type_cards__wifi__title',
	[QR_TYPE.App]: 'generator__step_1__qr_type_cards__app__title',
	[QR_TYPE.Menu]: 'generator__step_1__qr_type_cards__menu__title',
} as const satisfies Record<QR_TYPE, string>

export const getQrTypeTranslation =
	(t: TTranslationFunction) => (type: QR_TYPE | null | undefined) => {
		if (!type) {
			return ''
		}

		const translationKey = QR_TYPE_TO_TRANSLATION_KEY[type]

		if (!translationKey) {
			return ``
		}

		return t(translationKey)
	}
